import { render, staticRenderFns } from "./CustomerAddressUploadItem.vue?vue&type=template&id=272aa650&"
import script from "./CustomerAddressUploadItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressUploadItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports